import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-check\"><path d=\"M10.06 1.203 5.065 7.625 1.92 4.052a.52.52 0 0 0-.894.194.55.55 0 0 0 .11.528l3.562 4.047c.1.114.243.179.392.179h.017c.155-.005.3-.08.397-.204l5.382-6.92a.548.548 0 0 0-.085-.759.52.52 0 0 0-.741.086Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol